<template>
  <main>

    <div class="path">
      <i class="el-icon-caret-right"></i>操作历史记录
      <i class="el-icon-arrow-right"></i>&nbsp;视频观看记录
    </div>

    <br>
    <div class="content-wrapper">
      <el-form :inline="true" label-width="120px">
        <div class="item-wrapper">
          <div class="item-content clearfix">

            <el-form-item label="日期" class="query-item">
              <el-date-picker
                v-model="createTime"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                :editable='false'
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="课程名称" style="margin-bottom: 0px;">
              <el-input v-model="name" type="text" clearable
                        style="width: 220px">
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleQuery">查 询</el-button>
            </el-form-item>

            <el-form-item>
              <el-button icon="el-icon-refresh-left" @click="handleReset">重 置</el-button>
            </el-form-item>
          </div>

        </div>
      </el-form>
    </div>

    <section class="content_wrapper">
      <el-table
        :data="tableData.list"
        v-loading="loading"
        @row-click="playCourse"
        stripe
        style="width: 100%">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ (currentPage-1) * pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column
          prop="loginPhone"
          label="用户手机"
          width="150">
        </el-table-column>
        <el-table-column
          prop="courseName"
          label="课程名称"
          width="180">
        </el-table-column>
        <el-table-column
          prop="videoName"
          label="视频名称"
          width="540">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="观看时间">
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>

    </section>
  </main>
</template>

<style>
  .el-table .success-cell {
    background: #F0F9EB;
    font-weight: bold;
  }
</style>

<script>
import {mapState, mapGetters} from 'vuex'
import {
  reqFindAllVideoClickHistory
} from '@/api'

export default {
  name: 'CVideoClickHistory',

  data() {
    return {
      tableData: {},
      loading: true,
      hasRecords: false,
      name: '',
      createTime: '',
      currentPage: 1,
      total: 0,
      pageSize: 50,

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },

  async mounted () {
    const result = await reqFindAllVideoClickHistory(this.phone, '', '', '', this.currentPage)
    if (result.code === 0) {
      this.tableData = result.data
      this.loading = false
      this.total  = result.data.total
      this.pageSize  = result.data.pageSize
    } else {
      this.$message.error('数据查询失败，错误信息: ' + result.message)
    }
  },

  methods: {
    async handleCurrentChange(val) {
      const startDay = this.createTime ? this.createTime[0] + ' 00:00:00' : ''
      const endDay = this.createTime ? this.createTime[1] + ' 23:59:59' : ''

      this.currentPage = val
      this.loading = true
      const result = await reqFindAllVideoClickHistory(this.phone, this.name, startDay, endDay, this.currentPage)
      if (result.code === 0) {
        this.tableData = result.data
        this.total  = result.data.total
        this.pageSize  = result.data.pageSize
        this.loading = false
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    handleQuery () {
      this.tableData = {}
      this.handleCurrentChange(1)
    },

    handleReset() {
      this.phone = ''
      this.name = ''
      this.createTime = ''
      this.handleQuery()
    },

    playCourse (row, column, event) {
      if (!this.isLogin) {
        this.$message({
          message: '请先登录',
          type: 'error'
        })
        return
      }

      // 要加上catch语句，要不然会因为没有登录无法跳转到/playCourse 从而导致push报错
      // this.$router.push({
      //   path: '/playCourse',
      //   query: {no: row.no, videoNo: row.videoNo}
      // }).catch(err=>{})

      // 打开新的页面
      let {href} = this.$router.resolve(
        {
          path: '/playCourse',
          query: {
            no: row.no,
            videoNo: row.videoNo
          }
        }
      )
      window.open(href, '_blank')

    },
  },

  computed: {
    ...mapState(['phone']),
    ...mapGetters(['isLogin']),
  }

}
</script>

<style scoped>

  main {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .content_wrapper {
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px auto;
  }

  .search_bar {
    width: 800px;
    margin: 20px auto;
  }

  .search_result_tip {
    color: #909399;
    font-size: 14px;
    line-height: 50px;
  }

  .btn {
    width: 140px;
    margin: 20px auto;
  }

  .path {
    height: 40px;
    line-height: 40px;
    padding-left: 16px;
    font-size: 14px;
    color: #666;
  }

  .no_data_tip {
    display: flex;
    width: 100%;
    justify-content: center;
    font-size: 14px;
    color: #666;
    line-height: 40px;
  }

  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background: #99CCFF !important;
    cursor:pointer !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/VideoClickHistory/VideoClickHistory.vue